export const configuration = {
  serviceUrls: {
    msx: 'https://merchandising-site-experience.prod.merch.vpsvc.com/api/',
    merchantProductOrchestration: 'https://merchant-orchestration-api.products.cimpress.io/',
    cimpressLogoRendering: 'https://logo.rendering.cimpress.io/',
    lookupPreview: 'https://lookup.previews.cimpress.io/',
    docAssets: 'https://assets.documents.cimpress.io/',
  },
  requestor: 'bulma-pdp-herocarousel-fragment',
  mcpAuth: {
    mcpClientId: process.env.MCP_CLIENT_ID,
    mcpClientSecret: process.env.MCP_CLIENT_SECRET,
  },
  redis: {
    host: process.env.REDIS_HOST!,
    port: parseInt(process.env.REDIS_PORT!),
  },
};
